import { OrbitControls, useAnimations, useGLTF } from "@react-three/drei";
import { useEffect, useMemo, useRef, useState } from "react";
import { useKeyboard } from "../hooks/useKeyboard";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";
import { Map } from "./Map";
let walkDirection = new THREE.Vector3();
let rotateAngle = new THREE.Vector3(0, 1, 0);
let rotateQuaterion = new THREE.Quaternion();
let cameraTarget = new THREE.Vector3();



const directionOffset = ({
  moveForward,
  moveBackward,
  moveLeft,
  moveRight,
}) => {
  var directionOffset = 0;
  if (moveForward) {
    if (moveLeft) {
      directionOffset = Math.PI / 4; // w+a
    } else if (moveRight) {
      directionOffset = -Math.PI / 4; // w+d
    }
  } else if (moveBackward) {
    if (moveLeft) {
      directionOffset = Math.PI / 4 + Math.PI / 2; // s+a
    } else if (moveRight) {
      directionOffset = -Math.PI / 4 - Math.PI / 2; // s+d
    } else {
      directionOffset = Math.PI; // s
    }
  } else if (moveLeft) {
    directionOffset = Math.PI / 2; // a
  } else if (moveRight) {
    directionOffset = -Math.PI / 2; //d
  }

  return directionOffset;
};

const Player = (props) => {
  const position = useMemo(() => props.position, []);
  const model = useGLTF("./player.glb");
  console.log(model)
  console.log(position)
  const { actions } = useAnimations(model.animations, model.scene);
  const { moveBackward, moveForward, moveRight, moveLeft, jump, shift } =
    useKeyboard();

  //   console.log(model);
  const currentAction = useRef("");
  const controlsRef = useRef(OrbitControls);
  const camera = useThree((state) => state.camera);
  const playerRef = useRef();
  const updateCameraTarget = (moveX, moveZ) => {
    // move camera
    camera.position.x += moveX;
    camera.position.z += moveZ;
    // update camera target
    cameraTarget.x = model.scene.position.x;
    cameraTarget.y = model.scene.position.y + 2;
    cameraTarget.z = model.scene.position.z;

    if (controlsRef.current) controlsRef.current.target = cameraTarget;
  };

  useEffect(() => {
    let action = "";
    if (moveBackward || moveForward || moveRight || moveLeft) {
      action = "walking";
      if (shift) {
        action = "running";
      }
    } else if (jump) {
      action = "jumping";
    } else {
      action = "idle";
    }

    if (currentAction.current != action) {
      const nextActionToPlay = actions[action];
      const current = actions[currentAction.current];
      current?.fadeOut(0.2);
      nextActionToPlay?.reset().fadeIn(0.2).play();
      currentAction.current = action;
    }
    console.log(playerRef)



    // actions?.jumping?.play();
  }, [moveBackward, moveForward, moveRight, moveLeft, jump, shift]);


  useFrame((state, delta) => {
    if (
      currentAction.current == "running" ||
      currentAction.current == "walking"
    ) {
      let angleYCameraDirection = Math.atan2(
        camera.position.x - playerRef.current.position.x,
        camera.position.z - playerRef.current.position.z
      );

      let newDirectionalOffset = directionOffset({
        moveForward,
        moveBackward,
        moveLeft,
        moveRight,
      });

      //rotate model
      rotateQuaterion.setFromAxisAngle(
        rotateAngle,
        angleYCameraDirection + newDirectionalOffset
      );
      model.scene.quaternion.rotateTowards(rotateQuaterion, 0.2);

      //calculate direction
      camera.getWorldDirection(walkDirection);
      walkDirection.y = 0;
      walkDirection.normalize();
      walkDirection.applyAxisAngle(rotateAngle, newDirectionalOffset);

      //run/walk velocity
      const velocity = currentAction.current == "running" ? 10 : 5;

      //newmodel & camera
      const moveX = walkDirection.x * velocity * delta;
      const moveZ = walkDirection.z * velocity * delta;
      playerRef.current.position.x += moveX;
      playerRef.current.position.z += moveZ;
      updateCameraTarget(moveX, moveZ);
    }
  });
  return (
    <>
      <Map />
      <OrbitControls ref={controlsRef} />
      <primitive ref={playerRef} object={model.scene} />
    </>
  );
};

export default Player;
